(function () {
  if (window.customElements.get('gc-gift-card-pdp')) return;

  function digits(value) {
    return String(value || '').replace(/[^\d]/g, '');
  }

  class GcGiftCardPdp extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      this.img = this.querySelector('[data-gc-image]');
      this.amountEls = this.querySelectorAll('[data-gc-amount]');
      this.priceEl = this.querySelector('[data-gc-price]');
      this.idInput = this.querySelector('[data-gc-variant-id]');
      this.buttons = this.querySelectorAll('[data-gc-denom]');
      this.mediaByAmount = {};

      try {
        this.mediaByAmount = JSON.parse(this.querySelector('[data-gc-media-map]').textContent);
      } catch (e) {
        this.mediaByAmount = {};
      }

      this.buttons.forEach(function (btn) {
        btn.addEventListener('click', this.onSelect.bind(this));
      }, this);
    }

    onSelect(event) {
      var btn = event.currentTarget;
      if (btn.classList.contains('is-selected')) return;

      this.buttons.forEach(function (item) {
        item.classList.toggle('is-selected', item === btn);
        item.setAttribute('aria-pressed', item === btn ? 'true' : 'false');
      });

      var variantId = btn.getAttribute('data-variant-id');
      var money = btn.getAttribute('data-money');
      var image = btn.getAttribute('data-image');
      var amountKey = digits(btn.getAttribute('data-amount-key'));

      if (this.idInput) this.idInput.value = variantId;
      this.amountEls.forEach(function (el) {
        el.textContent = money;
      });
      if (this.priceEl) this.priceEl.textContent = money;

      var mapped = this.mediaByAmount[amountKey] || this.mediaByAmount[btn.getAttribute('data-variant-id')];
      var nextImage = (mapped && mapped.src) || image;
      this.swapImage(nextImage);

      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variantId);
        window.history.replaceState({}, '', url);
      }
    }

    swapImage(src) {
      if (!this.img || !src || this.img.getAttribute('src') === src) return;
      var frame = this.img.closest('.gc-pdp__frame');
      if (frame) frame.classList.add('is-swapping');
      window.setTimeout(function () {
        this.img.setAttribute('src', src);
        if (frame) frame.classList.remove('is-swapping');
      }.bind(this), 160);
    }
  }

  window.customElements.define('gc-gift-card-pdp', GcGiftCardPdp);
})();
